import React from "react";
import plusWhiteIcon from "../../assets/plus-icon-white.svg"
import plusBlackIcon from "../../assets/plus-button-black.svg"
import minusBlackIcon from "../../assets/minus-icon-black.svg"

import styles from "./style.module.sass"


interface IProps {
    onClick: (e: React.MouseEvent) => void;
    disabled?: boolean,
    size?: "small" | "default",
    background?: string | undefined | null
}

export const PlusButton = (props: IProps) => {
    const size = props.size || "default";

    let classes = [styles.plusButton];

    if(size === 'small'){
        classes.push(styles.small);
    }
    return <div className={classes.join(" ")} onClick={props.onClick}>
        <img src={plusBlackIcon} alt=""/>
    </div>
};

export const PlusPrimaryPinkButton = (props: IProps) => {
    return <div className={styles.plusPrimaryPinkButton} style={{background: props.background || '#FF2C3D'}} onClick={props.onClick}>
        <img src={plusWhiteIcon} alt=""/>
    </div>
};

export const PlusGreyButton = (props: IProps) => {
    return <div className={styles.plusPrimaryGreyButton} onClick={props.onClick}>
        <img src={plusBlackIcon} alt=""/>
    </div>
};


export const MinusButton = (props: IProps) => {
    const size = props.size || "default";

    let classes = [styles.plusButton];

    if(size === 'small'){
        classes.push(styles.small);
    }
    return <div className={classes.join(" ")} onClick={props.onClick}>
        <img src={minusBlackIcon} alt=""/>
    </div>
};


export const PrimaryButton = (props: IProps & {title: string | any}) => {
    const classes = [styles.primaryButton];
    if(props.disabled){
        classes.push(styles.disabled)
    }

    const backgroundStyles = {}

    if (!props.disabled) {
        // @ts-ignore
        backgroundStyles['background'] = props.background || '#FF2C3D'
    }

    return <div onClick={props.onClick} style={backgroundStyles} className={classes.join(" ")}>
        {props.title}
    </div>
};
